import {
  BlogSideBar,
  Box,
  InputBox,
  CarSelector,
  ChatBot,
  FeaturedProduct,
  RelatedProductSlider,
  MapWithMarker,
  TrashConfirmModal,
  FreeInspection,
  GuestCarQueryModal,
  HomeSlider,
  HomeSliderProduct,
  KeyFeatures,
  Modal,
  OurWorkingProcess,
  PackagesData,
  PremiumServices,
  ProductBox,
  ProfileSideBar,
  SecureSection,
  Share,
  SubscriptionData,
  WelcomeTo,
  UserImage,
  TopNavbarBanner,
  TestimonialWeb,
  Table,
  ImportResult,
  MediaBox,
  FranchiseCTA,
  MobileApp,
  PropertyRequirements,
  StoreLocatorSideBar,
  DownloadTheApp,
  RecentPosts,
  RecentServices,
  SubscriptionBar,
  SubscriptionForm,
  FormSlider,
  DetailingServices,
  BookServiceForm,
  CartSingleItem,
  TimeSlots,
  FeaturedServices,
  ShowServices,
  StepProvide,
  PostMeta,
} from "../component";

const components = {
  BlogSideBar,
  Box,
  InputBox,
  CarSelector,
  ChatBot,
  FeaturedProduct,
  RelatedProductSlider,
  MapWithMarker,
  TrashConfirmModal,
  FreeInspection,
  GuestCarQueryModal,
  RecentServices,
  HomeSlider,
  HomeSliderProduct,
  KeyFeatures,
  RecentPosts,
  Modal,
  DetailingServices,
  OurWorkingProcess,
  PackagesData,
  PremiumServices,
  ProductBox,
  ProfileSideBar,
  SecureSection,
  SubscriptionBar,
  SubscriptionForm,
  FormSlider,
  BookServiceForm,
  CartSingleItem,
  TimeSlots,
  FeaturedServices,
  ShowServices,
  StepProvide,
  PostMeta,
  Share,
  SubscriptionData,
  WelcomeTo,
  UserImage,
  TopNavbarBanner,
  TestimonialWeb,
  Table,
  ImportResult,
  MediaBox,
  FranchiseCTA,
  MobileApp,
  PropertyRequirements,
  StoreLocatorSideBar,
  DownloadTheApp,
};

export const useComponent = (component: string) => {
  return components[component];
};
